export function isComponentViewerItemReadonlyItem(item) {
    return 'readonlyItem' in item;
}
